import { Fetch } from '../utils'
import { ApiEndpoints } from '../constants'
import type {
  Account,
  GlobalErrorHandler,
  HistoricalAccountBalance,
  MonthlyAccountBalance,
} from '..'

export class AccountApi {
  fetchInstance: Fetch

  constructor(endpoint: string, token: string, onError?: GlobalErrorHandler) {
    this.fetchInstance = new Fetch(endpoint, token, undefined, onError)
  }

  createAccount = async (account: Account) => {
    return this.fetchInstance.post(ApiEndpoints.ACCOUNTS, account).then((data) => data.account)
  }

  deleteAccount = async (accountGuid: string) => {
    return this.fetchInstance.delete(`${ApiEndpoints.ACCOUNTS}/${accountGuid}`)
  }

  getAccounts = async () => {
    return this.fetchInstance.get(ApiEndpoints.ACCOUNTS).then((data) => data.accounts)
  }

  getInstitutions = async () => {
    return this.fetchInstance.get(ApiEndpoints.INSTITUTIONS).then((data) => data)
  }

  getMembers = async () => {
    return this.fetchInstance.get(ApiEndpoints.MEMBERS).then((data) => data.members)
  }

  getHistoricalAccountBalances = async (guid: string): Promise<HistoricalAccountBalance[]> => {
    return this.fetchInstance
      .get(`${ApiEndpoints.ACCOUNTS}/${guid}/historical_account_balances`)
      .then((data) => data.historical_account_balances)
  }

  getMonthlyAccountBalances = async (guid: string): Promise<MonthlyAccountBalance[]> => {
    return this.fetchInstance
      .get(`${ApiEndpoints.ACCOUNTS}/${guid}/monthly_account_balances`)
      .then((data) => data.monthly_account_balances)
  }

  mergeAccounts = async (accountGuids: string[]) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.ACCOUNTS}/merge`, { accounts: accountGuids })
      .then((data) => data)
  }

  refreshAllMembers = async () => {
    return this.fetchInstance.get(`${ApiEndpoints.MEMBERS}/refresh_all`).then((data) => data)
  }

  updateAccount = async (account: Account) => {
    return this.fetchInstance
      .put(`${ApiEndpoints.ACCOUNTS}/${account.guid}`, account)
      .then((data) => data.account)
  }
}
